import { FeatureFlags } from '@/api/api';
import { SHOW_ADS, SET_FEATURE_FLAGS, FETCH_FEATURE_FLAGS } from '../types';

// How long a fetched value is trusted before we refetch. This caps how long a
// long-lived session keeps a stale flag: after a production change, an open tab
// picks it up on its next navigation once the value is older than the TTL.
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

// De-duplicates concurrent fetches (e.g. sidebar + route guard on first load).
let inFlight = null;

export const state = () => ({
  // Fail-open defaults: until the config loads we behave as if ads are enabled
  // so a transient error never locks users out of the advertisement section.
  showAds: true,
  // Epoch ms of the last successful fetch; 0 means "never fetched".
  fetchedAt: 0,
});

export const getters = {
  [SHOW_ADS]({ showAds }) {
    return showAds;
  },
};

export const mutations = {
  /* eslint-disable no-param-reassign */
  [SET_FEATURE_FLAGS](stateObj, flags = {}) {
    stateObj.showAds = flags.showAds !== false;
    stateObj.fetchedAt = Date.now();
  },
  /* eslint-enable no-param-reassign */
};

export const actions = {
  [FETCH_FEATURE_FLAGS]({ commit, state: moduleState }) {
    const isFresh = Date.now() - moduleState.fetchedAt < CACHE_TTL;
    if (isFresh) return Promise.resolve();

    if (!inFlight) {
      inFlight = FeatureFlags.getConfig()
        .then(flags => commit(SET_FEATURE_FLAGS, flags))
        // Keep the previous value (fail-open on first load) and, since we don't
        // update fetchedAt, allow a retry on the next navigation.
        .catch(() => {})
        .finally(() => {
          inFlight = null;
        });
    }

    return inFlight;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
